import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks/core';
import { SafeDepositRentalFields } from './SafeDepositRentalFields.js';
import { SafeDepositRentalTotal } from './SafeDepositRentalTotal.js';
import { getBranch } from './utils.js';
export const SafeDepositRentalForm = JSX((props) => {
    const { regions, data, branches, onChange, onClick } = props;
    useEffect(() => {
        onChange({
            selectedBranch: '',
            selectedCaseVolume: '',
            selectedBoxSize: '',
        });
    }, [data.selectedRegion, onChange]);
    const branch = getBranch(branches, data.selectedBranch);
    const caseVolumes = getCaseVolumes(branch?.safeBoxCaseVolumes);
    const safeBoxCases = getCaseVolume(branch?.safeBoxCaseVolumes, data.selectedCaseVolume)?.safeBoxCases;
    const tariffs = getTariffs(safeBoxCases, data.selectedBoxSize);
    return (_jsxs("div", { className: "flex flex-col @4xl:flex-row gap-4xl align-top", children: [_jsx(SafeDepositRentalFields, { ...data, regions: regions, onClick: onClick, branches: branches, caseVolumes: caseVolumes, safeBoxCases: safeBoxCases, onChange: onChange }), _jsx(SafeDepositRentalTotal, { days: data.days, tariffs: tariffs })] }));
});
const getCaseVolumes = (safeBoxCaseVolumes) => safeBoxCaseVolumes?.length ? safeBoxCaseVolumes?.filter((_) => _?.safeBoxCases?.length) : [];
const getCaseVolume = (caseVolumes, selectedCaseVolume) => caseVolumes?.find((_) => _.volume === selectedCaseVolume);
const getTariffs = (safeBoxCases, selectedBoxSize) => safeBoxCases?.find((_) => _.safeBoxCasesSize === selectedBoxSize)?.tariffs;
//# sourceMappingURL=SafeDepositRentalForm.js.map